import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import {pages, sdoNs} from '../constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
import '../session-sdo';
import {apiRequestInstance, ApiService} from '@modules/api-service';
import {routerInstance} from '@aofl/router';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {tierStructure} from '@modules/i18n-labels';

/**
 * @summary ImpersonatingBanner
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('impersonating-banner')
class ImpersonatingBanner extends mapStatePropertiesMixin(i18nMixin(AoflElement)) {
  /**
   * Creates an instance of SiteHeader.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static get is() {
    return 'impersonating-banner';
  }

  @property({type: Object, attribute: false, mapState: `${sdoNs.SESSION}.current_role`, store: storeInstance})
  role = {};

  @property({type: String, attribute: false})
  tierLabel = '';

  async switchRole() {
    try {
      apiRequestInstance.purgeCache();
      const response = await ApiService.userValidate(this.role.inherited_role_id);
      localStorage.setItem('group_id', response?.current_role?.group_id);
    } catch (e) {}

    storeInstance.purge();
    routerInstance.navigate(pages.DASHBOARD, {forceReload: true});
  }

  async mapStateProperties() {
    const state = storeInstance.getState();
    const session = state[sdoNs.SESSION];

    this.tierLabel = session.$myGroups[session.currentLevel]?.label;
    if (session.currentLevel === session.$classLevel) {
      this.tierLabel = await tierStructure.CLASS;
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default ImpersonatingBanner;
